"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGENT_UPLOAD_REFUSAL_MESSAGES = exports.isAgentUploadRefusalReason = exports.AGENT_UPLOAD_REFUSAL_REASONS = exports.GcsFileUploadPath = exports.SshFileUploadPath = exports.AwsFileUploadPath = void 0;
exports.AwsFileUploadPath = "/file-upload/s3";
exports.SshFileUploadPath = "/file-upload/ssh";
exports.GcsFileUploadPath = "/file-upload/gcs";
exports.AGENT_UPLOAD_REFUSAL_REASONS = [
    "not_connected",
    "upgrade_required",
    "writes_not_enabled",
    "target_required",
    "forbidden",
    "environment_mismatch",
    "invalid_name",
    "outside_roots",
    "read_only_source",
    "read_only_root",
    "outside_source",
    "run_folder_unusable",
    "too_large",
    "staging_full",
    "too_many_in_flight",
    "file_exists",
    "parent_missing",
    "placement_unsupported",
    "placement_mismatch",
    "no_space",
    "permission_denied",
    "digest_mismatch",
    "already_set_up",
    "already_in_flight",
    "upload_failed",
    "agent_home_unknown",
];
const isAgentUploadRefusalReason = (value) => typeof value === "string" &&
    exports.AGENT_UPLOAD_REFUSAL_REASONS.includes(value);
exports.isAgentUploadRefusalReason = isAgentUploadRefusalReason;
exports.AGENT_UPLOAD_REFUSAL_MESSAGES = {
    not_connected: "Your agent for this run environment is not connected. Start it on the login node, then try again.",
    upgrade_required: "Your agent is too old to receive uploads. Update the agent on this host, then try again.",
    writes_not_enabled: "Your agent does not allow uploads into data folders. Configure a write folder on the agent, then try again.",
    target_required: "This upload did not say which run or data source it is for. Reload the page and try again.",
    forbidden: "You do not have access to this run or data source.",
    environment_mismatch: "This run or data source belongs to a different run environment.",
    invalid_name: "This file name cannot be used. Rename the file and try again.",
    outside_roots: "This folder is outside the data folders of this run environment.",
    read_only_source: "This data source is read only.",
    read_only_root: "This folder is read only on this run environment.",
    outside_source: "This folder is outside the data source's own folder.",
    run_folder_unusable: "This run has no usable work folder on the cluster. Check the run's work directory, then try again.",
    too_large: "This file is larger than the upload limit.",
    staging_full: "The server is busy with other uploads. Try again in a few minutes.",
    too_many_in_flight: "You already have the most uploads in progress that are allowed. Wait for one to finish.",
    file_exists: "A file with this name already exists. Rename the file or delete the existing one first.",
    parent_missing: "The destination folder does not exist on the cluster.",
    placement_unsupported: "The destination folder is on a filesystem that cannot place uploads safely. Ask your administrator for a different write folder.",
    placement_mismatch: "The file changed on the cluster while it was being placed, so it was not placed. Try the upload again.",
    no_space: "The cluster has no space left for this file.",
    permission_denied: "Your account on the cluster cannot write to this folder.",
    digest_mismatch: "The file arrived on the cluster damaged and was removed. Try the upload again.",
    already_set_up: "This upload connection is already set up. Reload the page and try again.",
    already_in_flight: "This file is already being uploaded. Wait for it to finish.",
    upload_failed: "The upload could not be completed. Try again.",
    agent_home_unknown: "Your agent has not reported its home folder, so data folders written with ~ cannot be used. Upgrade or reconnect the agent on this host, then try again.",
};
